import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { QuestionElement } from '../question-base';
import { QuestionRow } from '../question-row';
import { FormGroup } from '@angular/forms';
import { QuestionCol2 } from '../question-col2';
import { ModalQuestion } from '../question-modal';

@Component({
  selector: 'app-dynamic-form-builder',
  templateUrl: './dynamic-form-builder.component.html',
  styleUrls: ['./dynamic-form-builder.component.css']
})
export class DynamicFormBuilderComponent implements OnChanges {

  @Input() public question: any = null;
  @Input() public form: FormGroup = null;

  public isRow: boolean = false;
  public isCol: boolean = false;

  public subQuestions: Array<QuestionElement> = [];

  ngOnChanges( change ) {
    if (this.question) {
      if (this.question instanceof QuestionCol2) {
        this.isCol = true;
        this.subQuestions = (this.question as QuestionCol2).getQuestionsElementsInOrder();
      } else if (this.question instanceof QuestionRow) {
        if( !(this.question instanceof ModalQuestion) ){
          this.isRow = true;
          this.subQuestions = (this.question as QuestionRow).getQuestionsElementsInOrder();
        }
      }     
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/dynamic-form-builder/dynamic-form-builder.component.ts